/*! Grunt - v1.0.0 - 2018-09-12 11:37:35 */
$('html').removeClass('no-js');

$(function () {
    /* global Modernizr:true */



    var _this = this,
        _body = $('body');

    var zipcodes = [];

    /**
     * Initialize
     */
    _this.init = function()
    {
        $('a[rel="external"]').attr('target', '_blank');

        $('.hamburger').on('click', function() {
            $(this).parent().toggleClass('open');
            $(this).toggleClass('open');

            $('.language').toggleClass('open');

        });

        var request = jQuery.ajax({
            type: 'GET',
            url: '/ajax/get-zipcodes/',
            dataType: 'json',
            success: function(result) {
                if(result.status == 'success') {
                    zipcodes = result.data;
                    //console.log(zipcodes);
                }
            }
        });

        var totalItems = $('.item').length;
        var currentIndex = $('div.active').index() + 1;
        $('.position').html(''+currentIndex+'/'+totalItems+'');

        $('#carousel').on('slide.bs.carousel', function() {
            setTimeout(function(){
                currentIndexPop = $('#carousel div.active').index() + 1;
                $('.position').html('' + currentIndexPop + '/' + totalItems + '');
            }, 1);
        });

        $('#zipcode').on('keyup',function(event){

            var zipcode = $('#zipcode').val().substring(0,4);

            if(zipcode < 10) {
                zipcode *= 1000;
            } else if(zipcode < 100) {
                zipcode *= 100;
            } else if(zipcode < 1000) {
                zipcode *= 10;
            }

            //console.log('target: '+ zipcode);

            var closest_zipcode_index = _this.closest(zipcode);

            //console.log('closest: '+ zipcodes[closest_zipcode_index]);

            $('#carousel').carousel(closest_zipcode_index);//.pause();
            $('#carousel').carousel('pause');
        });

        $('#closestzipcode').submit(function(event){
            return false;
        });

        $('#navigation .menu li a').on('click', function() {
            console.log('test');
            $('#navigation').toggleClass('open');
            $('#navigation .hamburger').toggleClass('open');
        });

        $("div[id^='deur']").each(function(){

            var currentModal = $(this);

            //click next
            currentModal.find('.btn-next').click(function(){
                currentModal.modal('hide');
                currentModal.closest("div[id^='deur']").nextAll("div[id^='deur']").first().modal('show');
            });

            //click prev
            currentModal.find('.btn-prev').click(function(){
                currentModal.modal('hide');
                currentModal.closest("div[id^='deur']").prevAll("div[id^='deur']").first().modal('show');
            });

        });


    };

    _this.closest = function(num) {
        var curr = zipcodes[0];
        var diff = Math.abs (num - curr);
        for (var val = 0; val < zipcodes.length; val++) {
            var newdiff = Math.abs (num - zipcodes[val]);
            if (newdiff < diff) {

                diff = newdiff;
                curr = zipcodes[val];
            }
        }
        return zipcodes.indexOf(curr);
    };



    /**
     *  If body is not loaded, init
     */
    if (!_body.hasClass('loaded'))
    {
        _this.init();
    }
});